module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.448c34a5.woff2";